export default [
  {
    type: "monthly",
    year: 2021,
    month: 1,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 2,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 3,
    btc: 1565,
    source: "https://www.riotblockchain.com/news-media/press-releases/detail/105/riot-blockchain-announces-march-production-and-operations"
  },
  {
    type: "monthly",
    year: 2021,
    month: 4,
    btc: 1771,
    source: "https://www.riotblockchain.com/news-media/press-releases/detail/106/riot-blockchain-announces-april-production-and-operations"
  },
  {
    type: "monthly",
    year: 2021,
    month: 5,
    btc: 2000,
    source: "https://www.riotblockchain.com/news-media/press-releases/detail/110/riot-blockchain-announces-may-production-and-operations"
  },
  {
    type: "monthly",
    year: 2021,
    month: 6,
    btc: 2243,
    source: "https://www.riotblockchain.com/news-media/press-releases/detail/111/riot-blockchain-announces-june-production-and-operations"
  },
  {
    type: "monthly",
    year: 2021,
    month: 7,
    btc: 2687,
    source: "https://www.riotblockchain.com/news-media/press-releases/detail/112/riot-blockchain-announces-july-production-and-operations"
  },
  {
    type: "monthly",
    year: 2021,
    month: 8,
    btc: 3128,
    source: "https://www.riotblockchain.com/news-media/press-releases/detail/114/riot-blockchain-announces-august-production-and-operations"
  },
  {
    type: "monthly",
    year: 2021,
    month: 9,
    btc: 3534,
    source: "https://www.riotblockchain.com/news-media/press-releases/detail/116/riot-blockchain-announces-september-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 10,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 11,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 12,
    btc: 0,
    source: ""
  },
  /* Quarterly */
  {
    type: "quarterly",
    year: 2020,
    quarter: 1,
    btc: 0,
    source: "https://www.riotblockchain.com/news-media/press-releases/detail/82/riot-blockchain-reports-first-quarter-2020-financial"
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 2,
    btc: 0,
    source: "https://www.riotblockchain.com/news-media/press-releases/detail/86/riot-blockchain-reports-second-quarter-2020-financial"
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 3,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 4,
    btc: 0,
    source: "https://www.riotblockchain.com/news-media/press-releases/detail/101/riot-blockchain-announces-financial-highlights-for-the"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 1,
    btc: 1565,
    source: "https://www.riotblockchain.com/news-media/press-releases/detail/105/riot-blockchain-announces-march-production-and-operations"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 2,
    btc: 2687,
    source: "https://www.riotblockchain.com/news-media/press-releases/detail/113/riot-blockchain-reports-record-second-quarter-2021"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 3,
    btc: 3534,
    source: "https://www.riotblockchain.com/news-media/press-releases/detail/116/riot-blockchain-announces-september-production-and"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 4,
    btc: 0,
    source: ""
  },
]
